import { Action } from 'components/pages/task/action'
import { ApproveActionButton } from 'components/pages/task/action/button/ApproveActionButton'
import { DenyIcon, ApproveIcon } from 'components/pages/task/action/button/ButtonIcons'
import { CancelActionButton } from 'components/pages/task/action/button/CancelActionButton'
import { DenyActionButton } from 'components/pages/task/action/button/DenyActionButton'
import { MarkProvisionedActionButton } from 'components/pages/task/action/button/MarkProvisionedActionButton'
import { ReassignActionButton } from 'components/pages/task/action/button/ReassignActionButton'
import { TaskValue } from 'lib/actions/task'

export type OnActionFunc = (action: Action, task: TaskValue) => void

export type TaskActionButtonArgs = {
    task: TaskValue
    onAction: OnActionFunc
}

export {
    ApproveActionButton,
    DenyActionButton,
    MarkProvisionedActionButton,
    ReassignActionButton,
    CancelActionButton,
    DenyIcon,
    ApproveIcon,
}
